export default __webpack_public_path__ + "static/5-bccc97aad040731ab23ebf9410b831da.jpg";